import { Table, Input, Button, Space, Select } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { useRef, useState } from "react";
import { useFetchAllVehiclesQuery } from "../../../store/endpoints/trace/vehicles";
import Manage from "..";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import CreateWrapper from "./components/CreateWrapper";
import UpdateVehicle from "./components/UpdateVehicle";
import DeleteVehicle from "./components/DeleteVehicle";
import UploadWrapper from "./components/UploadWrapper";

export default function AllVehicles() {
  const { data: allVehicles, refetch, isLoading } = useFetchAllVehiclesQuery();

  const vehicles = !isLoading ? allVehicles && allVehicles.payload : [];
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [state, setState] = useState({ searchText: "", searchedColumn: "" });

  const seRef: any = useRef(Node);

  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={seRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            danger
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              handleReset(clearFilters);
              confirm({ closeDropdown: true });
              setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        setTimeout(() => seRef.select(), 100);
      }
    },
    render: (text: any) =>
      state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
    confirm();
    setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  const handleReset = (clearFilters: any) => {
    clearFilters();
    setState({ searchText: "", searchedColumn: "" });
  };

  const columns = [
    {
      title: "S/N",
      width: 50,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 250,
      render: (record: any) => (
        <span className="text-gray-700">{record?.contact?.customer?.name}</span>
      ),
    },
    {
      title: "Registration",
      width: 150,
      ...getColumnSearchProps("registration"),
      render: (record: any) => (
        <span className="text-gray-700">{record?.registration}</span>
      ),
    },
    {
      title: "Model",
      width: 120,
      ...getColumnSearchProps("model"),
      render: (record: any) => (
        <span className="text-gray-700">{record?.model}</span>
      ),
    },
    {
      title: "Mileage",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mileage ?? 0}
          <span className="ml-1">Km</span>
        </span>
      ),
    },
    // {
    //   title: "Year",
    //   width: 180,
    //   render: (record: any) => (
    //     <span className="text-gray-700">{record?.year ?? 0}</span>
    //   ),
    // },
    {
      title: "Action",
      width: 60,
      render: (record: any) => (
        <div className="flex justify-end">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  return (
    <Manage
      title={"Vehicles"}
      subtitle={"All"}
      description={"List of all vehicles"}
      actions={
        <div className="flex flex-row justify-between">
          <UploadWrapper />
          <CreateWrapper refetch={refetch} />
        </div>
      }
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            columns={columns}
            dataSource={vehicles}
            size="small"
            pagination={{ pageSize: 20 }}
            scroll={{ y: 420 }}
            loading={isLoading}
            rowKey="id"
          />
        </div>

        <UpdateVehicle
          selected={selected}
          isVisible={updateModal}
          setUpdateModal={setUpdateModal}
          refetch={refetch}
        />

        <DeleteVehicle
          selected={selected}
          isVisible={deleteModal}
          setDeleteModal={setDeleteModal}
        />
      </div>
    </Manage>
  );
}
